export default "__VITE_ASSET__T6ydsXRo__"